import { useSelector } from 'react-redux';
import { getFeatures } from '../../authSlice/authSelectors';

function useGetFeatures(): string[] {
  return useSelector(getFeatures);
}

export default useGetFeatures;
